import { render } from "./FooterBar.vue?vue&type=template&id=5c6eb9f4&scoped=true"
import script from "@/assets/js/Common/FooterBar.js?vue&type=script&lang=js&external"
export * from "@/assets/js/Common/FooterBar.js?vue&type=script&lang=js&external"

import "./FooterBar.vue?vue&type=style&index=0&id=5c6eb9f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6eb9f4"]])

export default __exports__